import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-footer-n',
  templateUrl: './footer-n.component.html',
  styleUrls: ['./footer-n.component.scss']
})
export class FooterNComponent implements OnInit {

  @Output() modalSelect = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  clickM() {
    this.modalSelect.emit(true);
  }

  descargaWin(): void {
    window.open('https://triidyftp.s3.us-east-2.amazonaws.com/Triidy.rar', '_blank');
  }

  descargaAnd(): void {
    window.open('https://play.google.com/store/apps/details?id=app.avalon.triidy', '_blank');
  }

}
